import {
    TCP_ROLES
} from "../components/util/Constants";

import { getUserEmployeeTCPRolesUsingUserId} from "../components/pickStatus/network/PickNetworkAPI";

import {getRegion} from "../components/util/Util";



/**

 *

 * @param {*} region

 * @returns Root AccountIds

 */
export const getValidTCPRolesList = (region) => {
    return TCP_ROLES[region];

}



/**

 *

 * @param {*} requestBody

 * @param {*} region

 * @returns if user has given tcp rol

 */
export const getTCPRoles = async (region) => {
    let isValidUser = false;

    await getUserEmployeeTCPRolesUsingUserId(getValidTCPRolesList(region)).then( () => {
        isValidUser = true;
    }).catch( () => {
        isValidUser = false;

    })

    return isValidUser;

}



/**
 *
 * @param {*} region

 * @returns Boolean value based on whether user with given loginId has given TCP Role in given accountId

 */
export const isValidRole = async (region) => {


    let isValidUser = false;

    isValidUser = await getTCPRoles(region);

    return isValidUser;

}



/**

 *

 * @returns Boolean value based on whether user is authorized to have write access in NodeResources tab

 */
export const isTCPAuthorizedUser = async (isTCPAuthorizationCheckEnabled) => {

    if (!isTCPAuthorizationCheckEnabled) {
        return true;

    }


    let isValidUser = false;

    await isValidRole(getRegion()).then(
        (isValidRoleResponse) => {
            isValidUser = isValidRoleResponse;

        })


    return isValidUser;

}





// WEBPACK FOOTER //
// ./src/helper/PickVisibilityAuthorizationHelper.js